import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge, IconButton, Tooltip } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

import { useGetCommentsComplaintsListQuery } from 'redux/rtk/comments/comments';
import { useGetMarathonReviewComplaintsQuery } from 'redux/rtk/marathonReviews/marathonReviews';
import { useGetMarathonCommentComplaintsQuery } from 'redux/rtk/marathonComments/marathonComments';
import { useAuth } from 'hooks/useAuth';
import { UserValues } from 'types/user';
import { PATH_DASHBOARD } from 'routes/paths';

const ALLOWED_ROLES = [UserValues.ADMIN, UserValues.MODERATOR, UserValues.SUPPORT];

const POLLING_INTERVAL = 60_000;
const QUERY_PARAMS = { user_id: 'n' as const, per_page: -1 };
const QUERY_OPTIONS = { pollingInterval: POLLING_INTERVAL };

export const CommentsComplaintsIndicator = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const hasAccess = user?.roles?.some((r) => ALLOWED_ROLES.includes(r.name));

  const options = { ...QUERY_OPTIONS, skip: !hasAccess };

  const { data: commentsData } = useGetCommentsComplaintsListQuery(QUERY_PARAMS, options);
  const { data: reviewComplaints } = useGetMarathonReviewComplaintsQuery(QUERY_PARAMS, options);
  const { data: commentComplaints } = useGetMarathonCommentComplaintsQuery(QUERY_PARAMS, options);

  const handleClick = useCallback(() => {
    navigate(PATH_DASHBOARD.comment.complaints);
  }, [navigate]);

  if (!hasAccess) return null;

  const count =
    (commentsData?.data?.length ?? 0) +
    (reviewComplaints?.data?.length ?? 0) +
    (commentComplaints?.data?.length ?? 0);

  return (
    <Tooltip title="Жалобы на отзывы и комментарии" arrow>
      <IconButton onClick={handleClick} size="small">
        <Badge badgeContent={count} color="error" max={99}>
          <ReportProblemOutlinedIcon color="action" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
